import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';
import theme from 'theme';

export const DragAndDropParagraph = styled(Typography)(() => ({
  fontSize: 14,
  fontWeight: 600,
  paddingBottom: '3px',
}));

export const FileName = styled(Typography)(() => ({
  fontSize: 13,
  fontWeight: 600,
  paddingBottom: '3px',
  color: '#000000',
}));

export const ProcessingText = styled(Typography)(() => ({
  fontSize: 13,
  fontWeight: 'normal',
  paddingBottom: '3px',
  color: '#000000',
}));

export const DropArea = styled(Box)(() => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  border: '2px dotted rgba(0, 140, 21, 0.4)',
  color: '#008c15',
  width: '100%',
  fontWeight: 'bold',
}));

export const Error = styled(Box)(() => ({
  position: 'absolute',
  paddingTop: '4px',
  bottom: 0,
  right: 8,
  color: theme.palette.error.main,
  fontSize: 12,
  fontWeight: 'normal',
}));
